import { render, staticRenderFns } from "./SuggestedVideos.vue?vue&type=template&id=2d184667&"
import script from "./SuggestedVideos.vue?vue&type=script&lang=js&"
export * from "./SuggestedVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports